import { render } from "./PracticeTestTaking.vue?vue&type=template&id=4bbc3039&scoped=true"
import script from "./PracticeTestTaking.vue?vue&type=script&lang=js"
export * from "./PracticeTestTaking.vue?vue&type=script&lang=js"

import "./PracticeTestTaking.vue?vue&type=style&index=0&id=4bbc3039&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbc3039"]])

export default __exports__